import { Button, ButtonGroup, Tooltip } from "@material-ui/core";
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import ConfirmationPopup from "components/ConfirmationPopup";
import NotificationProvider from "components/NotificationProvider";
import { NoteContent } from "features/notes/NoteContent";
import { selectIsClient } from 'features/user/userSlice';
import { useResolveFormResponseMutation } from "features/vehicles/VehicleCustomForm/CustomFormResponseSlice";
import { useState } from "react";
import { useSelector } from 'react-redux';
import FormatService from "services/formatService";
import { FormOutputStyle } from "./style";

const FormFailure = ({ customFormResponse, onClickFailure, showFailuresOnly, setShowFailuresOnly }) => {
    const classes = FormOutputStyle();
    const isClient = useSelector(selectIsClient);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [note, setNote] = useState({ content: '', viewByClient: isClient ? true : false });

    const [resolveForm, { isLoading: isResolving }] = useResolveFormResponseMutation();

    const handleNoteChange = (field, value) => {
        setNote({ ...note, [field]: value });
    }

    const handleResolve = async (note) => {
        const result = await resolveForm({
            id: customFormResponse?.id,
            isResolved: true,
            content: note?.content,
            viewByClient: note?.viewByClient,
            vehicleId: customFormResponse?.vehicleId,
        });
        if (result && !result.error) {
            NotificationProvider.success("Form resolved successfully");
        } else {
            NotificationProvider.error("Failed to resolve the form");
        }
        setOpenConfirmation(false);
    }

    const resolvedTooltipContent = () => (
        <>
            <div>Manually marked as resolved</div>
            {customFormResponse?.resolvedBy && <div>{customFormResponse?.resolvedBy}</div>}
            {customFormResponse?.resolutionDate && <div>{FormatService.formatDateTime(customFormResponse?.resolutionDate)}</div>}
        </>
    );

    const handleFailureClick = () => {
        if (onClickFailure != undefined)
            onClickFailure();
        else
            setShowFailuresOnly(!showFailuresOnly);
    }

    return (<>
        <ConfirmationPopup
            onCancel={() => setOpenConfirmation(false)}
            onConfirm={handleResolve}
            title="Mark as resolved"
            open={openConfirmation}
            loading={isResolving}
        >
            <div>Your about to override the forms failure and mark it as resolved </div>
            <div>Please enter a note </div><br />
            <NoteContent content={note.content} onChange={handleNoteChange} viewByClient={note.viewByClient} />
        </ConfirmationPopup>
        {customFormResponse?.isResolved ?
            (<ButtonGroup>
                <Tooltip title={resolvedTooltipContent()} placement="top">
                    <span>
                        <Button
                            variant="outlined"
                            startIcon={<ErrorOutlineRoundedIcon
                                className={classes.resolvedIcon}
                            />}
                            disabled
                            className={classes.resolvedButton}
                        >
                            Resolved
                        </Button>
                    </span>
                </Tooltip>
            </ButtonGroup>)
            : customFormResponse?.isFormFailed &&
            (<ButtonGroup>
                <Tooltip title={!showFailuresOnly ? "Show Failures Only" : "Show All"} placement="top">
                    <Button
                        variant="outlined"
                        startIcon={<ErrorOutlineRoundedIcon className={classes.failureIcon} />}
                        onClick={handleFailureClick}
                        className={classes.failureButton}
                    >
                        {!showFailuresOnly ? "Show Failures Only" : "Show All"}
                    </Button>
                </Tooltip>
                <Tooltip title="Mark as Resolved" placement="top">
                    <Button
                        className={classes.failureButton}
                        onClick={() => setOpenConfirmation(true)}
                    >
                        <CheckCircleOutlineRoundedIcon className={classes.failureIcon} />
                    </Button>
                </Tooltip>
            </ButtonGroup>)
        }
    </>
    )
}

export default FormFailure;